module.exports = __webpack_public_path__ + "static/media/SolutionsFifth.80bf5448.png";